import { useEffect, useState } from "react";

import { Link as RouteLink, useNavigate } from "react-router-dom";

import { Container } from "@mui/material";

import { Text, Button, Table, Pagination, Alert } from "@mantine/core";

import { IconReload, IconExclamationCircle } from "@tabler/icons-react";
import Cookies from "js-cookie";

import { usePerformRequest } from "../../Lib/usePerformRequest";
import { Client, PaginationProps } from "../../Lib/Types";
import { Endpoints } from "../../Lib/Endpoints";
import { PaginatedResponse } from "../../Lib/Responses";
import LoaderComp from "../../Components/LoaderComp";

import "./styles.scss";

const Clients: React.FC = () => {
  const navigate = useNavigate();
  const [pagination, setPagination] = useState<PaginationProps>({
    page: 1,
    limit: 20,
  });

  const [clients, setClients] = useState<Client[]>([]);

  const { data, reloadData, isLoading, status } = usePerformRequest<
    PaginatedResponse<Client[]>
  >({
    method: "POST",
    body: pagination,
    url: Endpoints.GetAllClients,
  });
  useEffect(() => {
    if (status === 401) {
      Cookies.remove("token");
      navigate("/login");
    }
    if (data && data?.data) {
      setClients(data.data);
    }
  }, [data, status]);

  useEffect(() => {
    reloadData();
  }, [pagination]);

  return (
    <div>
      <div className="header flex-row width-100 justify-between align-center">
        <Text fw={600} fz="xl" tt="capitalize">
          Clients
        </Text>
        <div className="flex-row align-center justify-center">
          <Button
            h={37}
            onClick={() => {
              reloadData();
            }}
            loading={isLoading}
            leftSection={<IconReload size={15} />}
          >
            Refresh
          </Button>
        </div>
      </div>

      {isLoading ? (
        <LoaderComp />
      ) : (
        <>
          <Table mt={20} verticalSpacing="md" withColumnBorders withTableBorder>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Name</Table.Th>
                <Table.Th>Email</Table.Th>
                <Table.Th>Details</Table.Th>
              </Table.Tr>
            </Table.Thead>

            <Table.Tbody>
              {clients.map((client, index) => {
                return (
                  <Table.Tr key={client.id}>
                    <Table.Td>
                      {client.firstname}&nbsp;
                      {client.lastname}
                    </Table.Td>
                    <Table.Td>{client.email}</Table.Td>
                    <Table.Td>
                      <RouteLink to={`/dashboard/client/${client.id}`}>
                        <Button variant="subtle">Details</Button>
                      </RouteLink>
                    </Table.Td>
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
          {clients?.length === 0 && (
            <Container maxWidth="sm">
              <Alert title="No results" mt={30}>
                <IconExclamationCircle color="var(--mantine-color-blue-6)" />
                <Text>No clients have registered!</Text>
              </Alert>
            </Container>
          )}
        </>
      )}

      <div className="flex-row align-center justify-center width-100">
        <Pagination
          mt={20}
          disabled={isLoading}
          value={pagination.page}
          onChange={(e) => setPagination({ ...pagination, page: e })}
          total={
            data && data.totalRecords
              ? data.totalRecords < 21
                ? 1
                : Math.ceil(data.totalRecords / 20)
              : 1 ?? 10
          }
        />
      </div>
    </div>
  );
};
export default Clients;
